import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { MasterService } from '../../../base-classes/master-service';
import { Screen } from '../../../shared/models/screen.interface';
import { ScreenMasterHelper } from '../helpers/screen-master.helper';

@Injectable({
  providedIn: 'root'
})
export class ScreenMasterService extends MasterService<Screen> {

  constructor(http: HttpClient) {
    const baseUrl = `${environment.apiUrl}/screen-master`;
    super(http, baseUrl);
  }

  /**
   * Get all screens with API response mapping
   */
   getAllScreenMaster(): Observable<Screen[]> {
    return this.http.get<any>(`${this.baseUrl}`).pipe(
      map(response => {
        const screens = response || [];
        return screens.map((item: any) => ScreenMasterHelper.mapFromAPI(item));
      })
    );
  }

  /**
   * Get screen by ID
   */
  getScreenMasterById(id: string): Observable<Screen> {
    return this.http.get<any>(`${this.baseUrl}/${id}`).pipe(
      map(response => ScreenMasterHelper.mapFromAPI(response))
    );
  }

  /**
   * Save screen (create or update)
   */
  saveScreenMaster(screen: Screen): Observable<Screen> {
    const payload = ScreenMasterHelper.mapToAPI(screen);
    
    return this.http.post<any>(`${this.baseUrl}`, payload).pipe(
      map(response => ScreenMasterHelper.mapFromAPI(response.data))
    );
  }

  /**
   * Delete screen by ID
   */
deleteScreenMaster(id: number | string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  /**
   * Get screen by screenId (stable identifier)
   */
  getByScreenId(screenId: string): Observable<Screen> {
    return this.http.get<Screen>(`${this.baseUrl}/by-screen-id/${screenId}`);
  }
}
